<template>
  <div>
    <v-row v-if="isError">
      <v-col cols="12">
        <v-alert type="error">
          {{ hosting_error }}
        </v-alert>
      </v-col>
    </v-row>
    <v-row v-if="!isError && inactiveService">
      <v-col cols="12" sm="6">
        <service-info />
      </v-col>
      <v-col cols="12" sm="6">
        <hosting-pending :status="hosting.status" />
      </v-col>
    </v-row>
    <v-row v-if="!isError && !inactiveService">
      <v-col cols="12">
        <gg-loading :loading="loading" type="image" height="86">
          <v-tabs flat background-color="transparent">
            <v-tabs-slider color="green" />
            <v-tab
              v-for="item in menu"
              :key="item.route"
              exact
              :to="{ name: item.route }"
            >
              {{ item.title }}
            </v-tab>
            <gg-btn color="primary" class="align-self-center v-tab" text exact @click="launch_whm(hostingid)">
              WHM
              <v-icon small class="ml-1">mdi-open-in-new</v-icon>
            </gg-btn>
          </v-tabs>
        </gg-loading>
        <hr class="mt-0">
      </v-col>
      <v-col cols="12" class="pt-0">
        <gg-loading :loading="loading" type="image" height="400">
          <router-view :loading="loading"/>
        </gg-loading>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ServiceInfo from 'Components/Services/Hosting/Common/ServiceInfo'
import HostingPending from 'Components/Services/Hosting/Common/HostingPending'
import { launch_whm } from '@/helpers/helpers'

export default {
  name: 'VpsService',
  components: {
    ServiceInfo, HostingPending
  },
  props: {
    loading: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    menu: [
      {
        title: 'Account Info',
        route: 'hosting_vserver_info',
        icon: 'mdi-information'
      },
      {
        title: 'IP Management',
        route: 'hosting_vserver_address',
        icon: 'mdi-map-marker'
      },
      {
        title: 'Reboot',
        route: 'hosting_vserver_reboot',
        icon: 'mdi-restart'
      },
      {
        title: 'Server Graphs',
        route: 'hosting_vserver_graphs',
        icon: 'mdi-chart-areaspline'
      },
      // {
      //   title: 'Password Management',
      //   route: 'hosting_vserver_password',
      //   icon: 'mdi-key-variant'
      // },
      {
        title: 'Add-ons',
        route: 'hosting_vserver_addons',
        icon: 'mdi-puzzle'
      },
    ],
    launch_whm,
  }),
  computed: {
    ...mapGetters(['hosting', 'hostingPopulated', 'hosting_error']),
    isError () {
      return this.hosting_error !== null
    },
    hostingid () {
      return this.$route.params.hostingid
    },
    inactiveService () {
      return this.hosting.status === 'Pending' || this.hosting.status === 'Suspended'
    },
  },
}
</script>
